import { Dispatch, SetStateAction, useState } from "react";
import { VideoData } from "@/redux/feature/videoDashboard/videoDashboardType";
import { useAddGetGenerateVideoScriptMutation } from "@/redux/feature/product/productApi";

import ModalVideoDetails from "./ModalVideoDetails";
import ModalVideoAnalysis from "./ModalVideoAnalysis";
import ModalGenerateScript from "./ModalGenerateScript";

interface ProductDetailsModalProps {
  video: VideoData;
  setIsDetailsModalOpen: Dispatch<SetStateAction<boolean>>;
  setIsSelectModalOpen: Dispatch<SetStateAction<boolean>>;
  showGenerateScript: boolean;
}

const ProductDetailsModal = ({
  video,
  setIsDetailsModalOpen,
  setIsSelectModalOpen,
  showGenerateScript,
}: ProductDetailsModalProps) => {
  const [currentTab, setCurrentTab] = useState<
    "videoDetails" | "generateScript" | "videoAnalysis"
  >("videoDetails");

  const [
    addGetVideoScript,
    { isLoading, isError, data: generatedVideoScripts },
  ] = useAddGetGenerateVideoScriptMutation();

  return (
    <>
      {(currentTab === "videoDetails" || currentTab === "videoAnalysis") && (
        <ModalVideoDetails
          showGenerateScript={showGenerateScript}
          video={video}
          currentTab={currentTab}
          setCurrentTab={setCurrentTab}
          addGetVideoScript={addGetVideoScript}
        />
      )}

      {currentTab === "generateScript" && (
        <ModalGenerateScript
          scripts={generatedVideoScripts?.data ?? []}
          currentTab={currentTab}
          setCurrentTab={setCurrentTab}
          setIsSelectModalOpen={setIsSelectModalOpen}
          setIsDetailsModalOpen={setIsDetailsModalOpen}
          isLoading={isLoading}
        />
      )}
    </>
  );
};

export default ProductDetailsModal;
